// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"261":"c3e731e5","715":"e344841e","965":"43f1930c"}[chunkId] + ".css";
};